<template>
  <v-container>
    <v-card flat>
      <v-data-table id="studentTable" :headers="headers" :items="studentList" :search="search" item-value="id"
        class="elevation-1 mt-4  display-table display" dense>
        <template v-slot:[`item.name`]="{ item }">
          <v-row align="center" no-gutters>
            <v-col class="d-flex align-center pa-2" :cols="3">
              <v-img :src="item.image || noImage" class="student-image mrr-10" alt="Student Image" />
              <span>{{ item.name }}</span>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.birth_date="{ item }">
          <span>{{ item.birth_date }}</span>
          <!-- <span>{{ formatDate(item.birth_date) }}</span> -->
        </template>
        <!-- <template v-slot:item.birth_date="{ item }">
          <span>{{ item.birth_date }}</span>
        </template> -->
        <template v-slot:item.class_name="{ item }">
          <span>
            {{
              classDropdownItems.find(cls => cls.value == Number(item.class_info))?.title || item.class_info
            }}
          </span>
        </template>


        <template v-slot:[`item.actions`]="{ item }">
          <!-- <div class="d-flex justify-space-between">
        <v-btn  @click="openEditStudent(item)">
          <span>Recovery</span>
        </v-btn>
        
      </div> -->
          <v-btn color="#129990" @click="openEditStudent(item)" style="width: 120px; height: 45px; border-radius: 0;"
            class="text-body-1" variant="flat">
            Recovery
          </v-btn>



        </template>

        <template v-slot:footer="{ props }">
          <v-row class="align-center">
            <v-col cols="auto">
              <span class="footer-text">Total Students:</span>
            </v-col>
            <v-col cols="auto">
              <v-data-table-footer :props="props" class="d-flex justify-start align-center" />
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog v-model="isDialogOpen" max-width="600px">
        <v-card v-if="selectedStudent">
          <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
          <v-card-text>
            <v-form ref="form" @submit.prevent="updateStudent">
              <v-text-field v-model="selectedStudent.name" label="Name" required />
              <v-text-field v-model="selectedStudent.id" label="Student ID" required />
              <v-select v-model="selectedStudent.class_info" :items="classDropdownItems" item-title="title"
                item-value="value" label="Select Class" outlined dense class="mt-4" />
              <!-- <v-text-field v-model="selectedStudent.section" label="Section" required /> -->
              <v-row class="justify-end m-2">
                <v-btn class="me-2" @click="updateStudent">Submit</v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card></v-container>




</template>

<script setup>
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";
import Swal from "sweetalert2";
import { ref, onMounted, computed, watch } from "vue";
import { useClassStore } from "@/Store/className";
// import { useSchoolStore } from "@/Store/schoolStore";
import { migratedStudent } from "@/services/apiServices";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"

// const schoolStore = useSchoolStore();
// schoolStore.fetchSchoolDetails();
// const schoolName = computed(() => schoolStore.details.id || '');
// const schoolName = computed(() => schoolStore.details || '');

const classStore = useClassStore();
const studentList = ref([]);
const selectedStudent = ref({});
const isDialogOpen = ref(false);
// const selectedClass = ref(null);
const error = ref(null);
const search = ref("");
const dialogTitle = ref("Recovery Students List");


watch(() => selectedStudent.class_info, (val) => {
  if (val && typeof val === 'string') {
    selectedStudent.class_info = Number(val);
  }
});



// Fetch class info on mount
onMounted(async () => {
  await classStore.fetchClassInfoList();
  await fetchMigratedStudents();

});

// Fetch migrated students list
const fetchMigratedStudents = async () => {
  try {
    const response = await migratedStudent();
    studentList.value = response;
  } catch (error) {
    console.error("Error fetching migrated students:", error);
  }
};

const classDropdownItems = computed(() => classStore.getClassDropdownItems);


// Handle select event
// const handleClassSelect = async (classId) => {
//   try {
//     const students = await classStore.fetchStudentsByClassId(classId);
//     studentList.value = students;
//   } catch (error) {
//     console.error("Error fetching students for class:", error);
//   }
// };

// const mapToSmallValue = (key, value) => {
//   const mapping = {
//     gender: {
//       Male: "male",
//       Female: "female",
//       Others: "others",
//     },
//   };
//   // console.log("maping ", mapping[key]?.[value]);
//   // console.log("not maping ", mapping[key]?.[value] || value);
//   return mapping[key]?.[value] || value;
// };

const updateStudent = async () => {

  const accessToken = localStorage.getItem("accessToken");
  const updatedData = { ...studentList.value };
  // console.log("updatedData:", updatedData);
  // console.log("Updating studentsss:", selectedStudent.value.class_name);
  try {
    const formData = new FormData();
    formData.append("is_migrated", false);
    formData.set("class_info", selectedStudent.value.class_info);
    // console.log("updateddata:", selectedStudent.value.id);
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.migratedstudentsDetail}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          "STUDENT-ID": selectedStudent.value.id,
        },
      }
    );
    isDialogOpen.value = false;
    studentList.value = studentList.value.filter(student => student.id !== selectedStudent.value.id);
    Swal.fire({
      icon: "success",
      title: "Student details have been updated successfully.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

  } catch (err) {
    console.error("Error updating student:", err);
    error.value = `Error updating student: ${err.response ? err.response.data : err.message
      }`;
  }
};


const headers = ref([
  { align: "start", key: "roll_symbol_no", sortable: true, title: "ROLL" },
  { key: "name", sortable: true, title: "NAME" },
  { key: "birth_date", sortable: true, title: "DOB" },
  { key: "class_name", sortable: true, title: "Class" },
  { key: "actions", sortable: false, title: "ACTION" },
]);

const openEditStudent = (student) => {
  selectedStudent.value = { ...student };
  isDialogOpen.value = true;
  // console.log("School Name:", selectedStudent);
};
</script>

<style></style>
